<div class="min-w-[320px]">
  <div
    class="flex items-center gap-2 justify-start text-lg font-semibold p-8 pb-2"
  >
    <mat-icon aria-hidden="true">info</mat-icon>
    <span>
      {{ data.entityLabel || 'Record Details' }}
    </span>
  </div>

  <mat-dialog-content>
    <div class="flex-col gap-2">
      @for (key of objectKeys; track key) {
        <div class="">
          <strong class="font-semibold text-black capitalize">{{ key }}:</strong>
          <span>{{ data.entity[key] }}</span>
        </div>
      }
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="mt-4">
    <app-button-generator
      text="COMMON.CLOSE"
      [variant]="ButtonVariant.PRIMARY"
      (function)="this.dialogReference.close()"
    />
  </mat-dialog-actions>
</div>
